"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExamQuestionStatsServiceClient = void 0;
var ExamQuestionStatsServiceClient_1 = require("./ExamQuestionStatsServiceClient");
Object.defineProperty(exports, "ExamQuestionStatsServiceClient", { enumerable: true, get: function () { return __importDefault(ExamQuestionStatsServiceClient_1).default; } });
//# sourceMappingURL=index.js.map